import { FaFacebookF } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import { FaTumblr } from 'react-icons/fa';
import { FaDiscord } from 'react-icons/fa';
import Video from './Video';
import Social from '../buttos/Social'
import './content.css';
import UserAppContext from '../../hook/UserAppContext';

const BoxContent = () => {

      const {user, dataApp} = UserAppContext()

      const {videos, social, infordata} = user.user 
      
      return (
            <div className="jd_theme__content">
                  <div className="container content">
                        <div className="jd_content__col">
                              <div className="jd_content__description">
                                    <p>{infordata.about === '' || infordata.data ? dataApp.info.about : infordata.about}</p>
                              </div>
                              {
                                    !social.data 
                                          ? 
                                                <div className="jd_content__social">
                                                      <h2>Social networks</h2>
                                                      <div className="jd_social__menu">
                                                            <Social link={social.facebook === '' || social.data ? dataApp.social.facebook : social.facebook} icon={<FaFacebookF/>} tooltip={`facebook`} />
                                                            <Social link={social.twitter === '' || social.data ? dataApp.social.twitter : social.twitter} icon={<FaTwitter/>} tooltip={`twitter`} />
                                                            <Social link={social.instagram === '' || social.data ? dataApp.social.instagram : social.instagram} icon={<FaInstagram />} tooltip={`instagram`} />
                                                            <Social link={social.youtube === '' || social.data ? dataApp.social.youtube : social.youtube} icon={<FaYoutube/>} tooltip={`youtube`} />
                                                            <Social link={social.tumblr === '' || social.data ? dataApp.social.tumblr : social.tumblr} icon={<FaTumblr/>} tooltip={`tumblr`} />
                                                            <Social link={social.tiktok === '' || social.data ? dataApp.social.tiktok : social.tiktok} icon={<SiTiktok/>} tooltip={`tiktok`} />
                                                            <Social link={social.discord === '' || social.data ? dataApp.social.discord : social.discord} icon={<FaDiscord/>} tooltip={`discord`} />
                                                      </div>
                                                </div>
                                          : ""
                              }
                              
                        </div>

                        <Video videos={videos}/>
                  </div>
            </div>
      )
}

export default BoxContent;